import { Module } from '../Module';

interface IPlaceDescriptionScope {
  type: string;
  id: string;
  description: string;
  showReadMore: () => boolean;
}

Module.instance().directive('tbPlaceDescription', <any[]>[
  '$state',
  ($state: ng.ui.IStateService) => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'placeDescription.html',
      scope: {
        type: '@',
        id: '=',
        description: '='
      },
      link: (scope: IPlaceDescriptionScope, element: JQuery) => {
        const holderElement = element.find('.tb-place-description-text-holder');
        scope.showReadMore = () => {
          return holderElement.get(0).scrollWidth > holderElement.width()
            && !$state.includes('**.details'); // Do not show link on details tab
        };
      }
    };
  }
]);
